import React, { useEffect } from 'react';
import { Header, MenuItemOption } from '../common_v2/components/Header';
import { Footer } from '../common_v2/components/Footer';
import { useAuthentication } from '../Login/hooks/useAuthentication';
import { RegisteredApplicantDashboard } from './components/RegisteredApplicantDashboard/RegisteredApplicantDashboard';
import { GeneralContractorDashboard } from './components/GeneralContractorDashboard/GeneralContractorDashboard';
import { useAuthenticationStore } from '../state/authenticationStore';
import { useNavigate } from 'react-router';
import { useWaitOverlayStore } from '@apply/components';

export const Home: React.FC = () => {
    useEffect(() => {
        useWaitOverlayStore.getState().setWaiting(false);
    }, []);
    const { authentication, isAuthenticated } = useAuthentication();
    const { isGeneralContractor, isRegistered } = authentication?.user || {};
    const navigate = useNavigate();
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                navigate('/login');
            }
        }
    }, [authentication, isAuthenticated]);

    const determineDashboard = () => {
        //General Contractor and Registered User
        if (isGeneralContractor && isRegistered) {
            return selectedAuthorizedDrawUserEntity ? <GeneralContractorDashboard /> : <RegisteredApplicantDashboard />;
        }

        //General Contractor Only
        if (isGeneralContractor) {
            if (!selectedAuthorizedDrawUserEntity) {
                navigate('/entity-selection');
                return null;
            }
            return <GeneralContractorDashboard />;
        }

        //Registered User Only
        if (isRegistered) {
            return <RegisteredApplicantDashboard />;
        }
        return null;
    };

    const displayedDashboard = determineDashboard();

    return (
        <>
            <div className='app-container'>
                <Header activeMenuItem={MenuItemOption.Home} />
                <main>{displayedDashboard}</main>
            </div>
            <Footer />
        </>
    );
};
